
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, InvoiceItemViewModel, InvoiceViewModel, IPayableItem, PayableCriteria, PayableViewModel } from "@tylertech/tyler-api-types";

/**
 * PayableService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PayableService {
    constructor(private readonly $apiService: ApiService) { }
    
    CreatePayments(pCriteria: PayableCriteria): Promise<void> {
        return this.$apiService.sendAuth("IPayableService/CreatePayments", pCriteria);
    }
    GetItems(pInvoiceId: string): Promise<InvoiceItemViewModel[]> {
        return this.$apiService.sendAuth("IPayableService/GetItems", pInvoiceId);
    }
    GetPayable(pPayableId: string): Promise<PayableViewModel> {
        return this.$apiService.sendAuth("IPayableService/GetPayable", pPayableId);
    }
    GetPayableIdListForPayment(pCriteria: PayableCriteria): Promise<string[]> {
        return this.$apiService.sendAuth("IPayableService/GetPayableIdListForPayment", pCriteria);
    }
    GetPayableItems(pPayable: PayableViewModel): Promise<IPayableItem[]> {
        return this.$apiService.sendAuth("IPayableService/GetPayableItems", pPayable);
    }
    ValidateInvoice(pInvoice: InvoiceViewModel): Promise<ExecutionResult<InvoiceViewModel>> {
        return this.$apiService.sendAuth("IPayableService/ValidateInvoice", pInvoice);
    }
}
